export default [
  {
    path: "/interviews",
    name: "interviews",
    page: "index",
    meta: {
      sortOrder: 999,
      module: "interviews",
      title: "interviews",
      drawer: true,
      main: true,
      breadcrumb: {
        label: "interviews",
        parent: "home",
      },
    },
  },
];
